/**
 * Add measureIds and incidentIds to simulations
 */
export default {
  applyToVersions: "<=2.2.0",
  type: "before",
  name: "remove effect directions",
  migrate(state) {
    if (!state?.effects) return state;
    if (!state?.effects?.items) return state;

    for (const effectId in state.effects.items) {
      const effect = state.effects.items[effectId];

      if (!("direction" in effect)) continue;

      effect.amount = effect.direction * effect.amount;
      delete effect.direction;
    }

    return state;
  }
};
